import React from 'react';

const Loader = props => {
  return (
    <div className='w-100 p-4 text-center text-muted'>{props.children}</div>
  );
};

export default Loader;
